import { Capacitor } from '@capacitor/core'
import { androidVersionCode, iosVersionCode } from '../../package.json'

export const appendAppVersionHeaders = (request, isMobileSystem) => {
  if (!isMobileSystem) return request

  if (Capacitor.getPlatform() === 'ios') {
    request.headers.ios_version = iosVersionCode
  } else if (Capacitor.getPlatform() === 'android') {
    request.headers.android_version = androidVersionCode
  }

  return request
}
